import type { Auth0ContextInterface } from '@auth0/auth0-react';

import { FetchWrapper } from '../helpers/fetch-wrapper';

export const storesBaseUrl = `${import.meta.env.VITE_SERVER_URL}/stores`;

export type TokenAccessor = Auth0ContextInterface['getAccessTokenSilently'];

// Every service under /stores is the same object: a FetchWrapper bound to the
// signed-in user's token. Inheriting the constructor keeps the seven of them
// from repeating it, and keeps `service.fetchWrapper` publicly assignable —
// the service tests swap it for a spy rather than stubbing global fetch.
export class StoreScopedService {
  fetchWrapper: FetchWrapper;

  constructor(tokenAccessor: TokenAccessor) {
    this.fetchWrapper = new FetchWrapper(tokenAccessor);
  }
}
